import React, { useState } from 'react';
import './SelectedChipList.scss';

export default function SelectedChipList({ items, onRemove, initialVisible = 8 }) {
  const [expanded, setExpanded] = useState(false);
  if (!items || items.length === 0) return null;

  const overflow = items.length - initialVisible;
  const showToggle = overflow > 0;
  const visible = showToggle && !expanded ? items.slice(0, initialVisible) : items;

  return (
    <div className={`selected-chip-list${expanded ? ' selected-chip-list--expanded' : ''}`}>
      {visible.map((item) => (
        <span key={item.value} className="selected-chip">
          {item.label}
          <button
            type="button"
            className="selected-chip__remove"
            aria-label={`Remove ${item.label}`}
            onClick={() => onRemove(item.value)}
          >
            X
          </button>
        </span>
      ))}
      {showToggle && (
        <button
          type="button"
          className="selected-chip-list__toggle"
          onClick={() => setExpanded((e) => !e)}
        >
          {expanded ? 'Show fewer' : `+${overflow} more`}
        </button>
      )}
    </div>
  );
}
